import { Component, Input } from '@angular/core';
import { IChatResponse } from '@common/models/Chat/IChatResponse';

@Component({
  selector: 'app-chat-response-table-chart',
  templateUrl: './chat-response-table-chart.component.html',
  styleUrl: './chat-response-table-chart.component.scss'
})
export class ChatResponseTableChartComponent {
  @Input() chatResponse: IChatResponse;


  toggleOptions = [
      { label: "Table", value: 'table' },
      { label: "Chart", value: 'chart' },
  ];
  toggleValue = 'table'



}
